var map = {
	"./block51.png": 9147,
	"./block52.png": 1782,
	"./block53.png": 7582,
	"./block54.png": 1478,
	"./block55.png": 60,
	"./block56.png": 5028,
	"./icon1.png": 8605,
	"./icon2.png": 5135,
	"./icon3.png": 7626,
	"./icon4.png": 9895,
	"./icon5.png": 8233,
	"./icon6.png": 6948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5608;